import React, { type FC } from 'react'
import { useIntl } from 'react-intl'
import { Flex, Link, LINK_VARIANT_DEFAULT } from 'mailup-web-components'
import { faPlus } from 'mailup-fontawesome-kit/classic/regular'
import { type IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAtomCallback } from 'jotai/utils'
import { openCategoryFormCallback } from '../callbacks/form'

const ActionAddCategory: FC = () => {
  const intl = useIntl()

  const handleClick = useAtomCallback(openCategoryFormCallback)
  return (
    <Flex justifyContent='space-between'>
      <div />
      <Flex alignItems='center'>
        <Link
          variant={LINK_VARIANT_DEFAULT}
          data-mu-test='category-add-category'
          onClick={() => {
            handleClick()
          }}
        >
          <Flex alignItems='center' gap='8px'>
            <FontAwesomeIcon icon={faPlus as IconProp} />

            <span>
              {intl.formatMessage({
                id: 'Load.FiltersCategories.ActionAddCategory',
              })}
            </span>
          </Flex>
        </Link>
      </Flex>
    </Flex>
  )
}

export default ActionAddCategory
